import Axios from "axios";
import ListDashboardLayoutsPage from "pages/dashboard-layouts/ListDashboardLayoutsPage";
import ViewDashboardLayoutPage from "pages/dashboard-layouts/ViewDashboardLayoutPage";
import { PagesConfig } from "PagesConfig";
import React from "react";
import { withTranslation } from 'react-i18next';
import { connect } from "react-redux";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { bindActionCreators } from "redux";
import packageJson from '../package.json';
import "./App.scss";
import PrimarySearchAppBar from "./components/layout/SplitView";
import { PrivateRoute } from "./components/private-route/PrivateRoute";
import CustomizedSnackbars from "./components/snackbar/Snackbar";
import { checkLoggedIn, getUserRoles, login } from "./config/azureConfig";
import "./index.css";
import AuthPage from "./pages/auth/AuthPage";
import HomePage from "./pages/home/HomePage";
import LoginPage from "./pages/login/LoginPage";
import NotFoundPage from "./pages/not-found/NotFoundPage";
import { updateVersion } from "./state/actions/VersionActions";
import { getCSVType } from "./state/constants/CSVType";
import { UserRoles } from "./state/constants/UserRoles";
// Style
import "./Theme.scss";

const flavour = process.env.REACT_APP_FLAVOUR;

class App extends React.Component {

  constructor(props) {
    super(props);

    this.setupInterceptor();

    this.state = {
      requestCount: 0,
      error: null,
      success: null,
      webRoutes: null
    }
  }

  componentDidMount() {


    const cachedVersion = this.props.version;
    const currenVersion = packageJson.version;

    if (cachedVersion !== currenVersion) {
      this.props.updateVersion(currenVersion);
    }

    this.setupLanguage();
    this.renderRoutes();

    checkLoggedIn((success) => {
      if (!success) {
        login()
      }
    })
  }

  setupLanguage() {
    const { i18n } = this.props;
    var language = "en"
    switch (flavour) {
      case "VN":
        language = "vi";
        break;
      case "SIMA":
        language = "sima"
      default:
        break;
    }

    i18n.changeLanguage(language);
  }

  setupInterceptor() {
    const { t } = this.props
    // Append the access token to all requests being sent...


    Axios.interceptors.request.use(config => {
      this.setState({ requestCount: this.state.requestCount + 1 })

      // const token = getToken();
      // getTokenAsync((errorDesc, token, error) => {
      //   config.headers.Authorization = token;
      //   return config;
      // });

      // config.headers.Authorization = token;
      return config;
    });

    Axios.interceptors.response.use(
      response => {

        const stateUpdate = { requestCount: this.state.requestCount - 1 }
        // success messages for get bloat the snackbar, don't show 
        if ((response?.config?.method || "get") !== "get") {
          stateUpdate.success = t("common.success")
        }
        this.setState(stateUpdate)

        // Do something with response data...
        return response;
      },
      error => {
        if (Axios.isCancel(error)) {
          // Cancel request
          this.setState({ requestCount: this.state.requestCount - 1, error: errorMessage });
          return Promise.reject(error);
        }
        var errorMessage = t("common.error")
        if (error.response && error.response.statusText) {
          errorMessage += `: ${error.response.statusText}`

          if (error.response.data) {
            const errorData = error.response.data;
            if (Array.isArray(errorData)) {
              errorData.forEach(error => {
                if (error.error_reason) {
                  errorMessage += ` - ${error.error_reason}`
                }
              });
            } else {

              if (errorData.error_message) {
                errorMessage += ` - ${errorData.error_message}`
              } else if (errorData.error_reason) {
                errorMessage += ` - ${errorData.error_reason}`
              }
            }

          }
          if (error.response.data.errors) {
            error.response.data.errors.forEach(error => {
              errorMessage += ` - ${error}`
            });
          }
        }
        this.setState({ requestCount: this.state.requestCount - 1, error: errorMessage });

        // Do something with response error...
        return Promise.reject(error);
      }
    );
  }

  renderRoutes() {
    getUserRoles(userRoles => {
      const { COMMERICAL, IT_ADMIN, DISTRIBUTOR } = UserRoles
      const flavour = process.env.REACT_APP_FLAVOUR
      const CSVType = getCSVType()

      const pages = []

      Object.values(PagesConfig()).forEach(page => {
        if (page.type == "link" && !!page.component) {
          const route = (
            <PrivateRoute
              key={page.route}
              exact={page.exact}
              path={page.route}
              component={page.component}
              roles={page.roles}
              userRoles={userRoles}
              type={page.pageType}
              urlOverride={page.csvUrlOverride}
            />
          )
          pages.push(route)
        }

        const children = Object.values(page.children || {})
        if (!!children && children.length > 0) {
          children.forEach(childPage => {
            const childPageRoute = page.route + childPage.route
            const childPagePrivateRoute = (
              <PrivateRoute
                key={childPageRoute}
                exact={childPage.exact}
                path={childPageRoute}
                component={childPage.component}
                roles={childPage.roles}
                userRoles={userRoles}
                type={childPage.pageType}
                urlOverride={page.csvUrlOverride}
              />
            )
            pages.push(childPagePrivateRoute)
          })
        }
      })

      this.setState({
        webRoutes: <Switch>
          {/* Public Routes */}
          <Route exact path="/" component={HomePage} />
          <Route path="/login" component={LoginPage} />
          <PrivateRoute path="/auth" component={AuthPage} />

          {/* Protected Routes */}
          {pages}

          <Route path="*" component={NotFoundPage} />

        </Switch>
      })
    });
  }

  render() {
    const { t } = this.props

    return (
      <div className={"content theme " + (true ? "theme--dark" : "theme--default")}>
        <Router basename="/web">
          <PrimarySearchAppBar isLoading={this.state.requestCount > 0}>
            <CustomizedSnackbars open={this.state.requestCount > 0} showLoading message={t("common.loading")} />
            <CustomizedSnackbars
              autoHideDuration={1000}
              handleClose={() => { this.setState({ success: null }) }}
              open={this.state.success != null}
              variant="success"
              message={this.state.success} />
            <CustomizedSnackbars
              handleClose={() => { this.setState({ error: null }) }}
              open={this.state.error != null}
              variant="error"
              message={this.state.error} />
            {this.state.webRoutes}
          </PrimarySearchAppBar>
        </Router>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const { version } = state.VersionReducer;
  return { version };
};

const mapDispatchToProps = dispatch => bindActionCreators({
  updateVersion
}, dispatch);

const hoc = connect(
  mapStateToProps,
  mapDispatchToProps
)(App);

// EXPORT COMPONENT

export default withTranslation()(hoc);